var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4232 8.57709C16.7487 8.90252 16.7487 9.43016 16.4232 9.7556L9.75657 16.4223C9.43114 16.7477 8.9035 16.7477 8.57806 16.4223C8.25263 16.0968 8.25263 15.5692 8.57806 15.2438L15.2447 8.57709C15.5702 8.25165 16.0978 8.25165 16.4232 8.57709Z",
    fill: "#CFC8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4993 16.667C14.8005 16.667 16.666 14.8015 16.666 12.5003C16.666 10.1991 14.8005 8.33366 12.4993 8.33366C10.1982 8.33366 8.33268 10.1991 8.33268 12.5003C8.33268 14.8015 10.1982 16.667 12.4993 16.667ZM12.4993 18.3337C15.721 18.3337 18.3327 15.722 18.3327 12.5003C18.3327 9.27866 15.721 6.66699 12.4993 6.66699C9.27769 6.66699 6.66602 9.27866 6.66602 12.5003C6.66602 15.722 9.27769 18.3337 12.4993 18.3337Z",
    fill: "#ffbb00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36132 1.77908C7.49288 1.554 8.66577 1.66952 9.73167 2.11103C10.5437 2.4474 11.2659 2.96148 11.8473 3.61144C12.1541 3.95448 12.1247 4.4813 11.7817 4.78812C11.4387 5.09495 10.9118 5.06559 10.605 4.72255C10.1897 4.25828 9.6739 3.89109 9.09386 3.65083C8.33251 3.33546 7.49473 3.25295 6.68647 3.41372C5.87822 3.57449 5.13579 3.97133 4.55307 4.55405C3.97035 5.13677 3.57352 5.8792 3.41275 6.68745C3.25197 7.49571 3.33449 8.33348 3.64985 9.09484C3.89011 9.67488 4.2573 10.1907 4.72157 10.606C5.06461 10.9128 5.09397 11.4396 4.78714 11.7827C4.48032 12.1257 3.9535 12.1551 3.61046 11.8482C2.9605 11.2669 2.44643 10.5447 2.11005 9.73265C1.66854 8.66674 1.55302 7.49386 1.7781 6.3623C2.00318 5.23075 2.55876 4.19134 3.37456 3.37554C4.19037 2.55973 5.22977 2.00416 6.36132 1.77908Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablets);
export default __webpack_public_path__ + "static/media/tablets.4e42ee51a7591211719b6d017159d845.svg";
export { ForwardRef as ReactComponent };